var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sidebar',[(_vm.hasContent)?_c('DividedSidebarList',{attrs:{"title":_vm.$t('Back_to_committee'),"subtitle":_vm.committee.title ? _vm.parent === _vm.committee : null,"parent":_vm.parent,"empty-message":"","items":_vm.committees}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }